module.exports = __webpack_public_path__ + "static/img/A108.082cd723.jpg";